module.exports = __webpack_public_path__ + "static/media/eagle.f817f552.jpg";